import React from "react";
import { MouseTracker } from "../../sections/home/components";
import Header from "./Header";
import Footer from "../Footer";

const ProjectsLayout = ({ children }) => {
	return (
		<div className="projects-list-layout">
			<MouseTracker />

			<Header />

			{children}
		</div>
	);
};

export default ProjectsLayout;

export { Header, Footer };
